import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { microsoftAuthApiRef } from '@backstage/core-plugin-api';

export const signInPageModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SignInPageBlueprint.make({
      params: {
        loader: async () => props => (
          <SignInPage
            {...props}
            providers={[
              {
                id: 'microsoft',
                title: 'Microsoft',
                message: 'Sign in with your Young Life Microsoft account',
                apiRef: microsoftAuthApiRef,
              },
              'guest',
            ]}
          />
        ),
      },
    }),
  ],
});
